export default "__VITE_ASSET__BUsBdMIu__"